export var euiZLevel0 = 0
export var euiZLevel1 = 1000
export var euiZLevel2 = 2000
export var euiZLevel3 = 3000
export var euiZLevel4 = 4000
export var euiZLevel5 = 5000
export var euiZLevel6 = 6000
export var euiZLevel7 = 7000
export var euiZLevel8 = 8000
export var euiZLevel9 = 9000
export var euiZContent = 0
export var euiZHeader = 1000
export var euiZContentMenu = 2000
export var euiZFlyout = 3000
export var euiZNavigation = 4000
export var euiZMask = 6000
export var euiZModal = 8000
export var euiZToastList = 9000
export default {"euiZLevel0":0,"euiZLevel1":1000,"euiZLevel2":2000,"euiZLevel3":3000,"euiZLevel4":4000,"euiZLevel5":5000,"euiZLevel6":6000,"euiZLevel7":7000,"euiZLevel8":8000,"euiZLevel9":9000,"euiZContent":0,"euiZHeader":1000,"euiZContentMenu":2000,"euiZFlyout":3000,"euiZNavigation":4000,"euiZMask":6000,"euiZModal":8000,"euiZToastList":9000}
